import wx from 'weixin-js-sdk' //微信JS-SDK
// var wx = require('./weixin-js-sdk.js') //微信JS-SDK
export default {
    install(Vue) {
        //是否登录状态
        function isLogin() {
            if (!window.sessionStorage.getItem("session") || window.sessionStorage.getItem("session") == "" ||
                window.sessionStorage.getItem("session") == undefined || window.sessionStorage.getItem("session") == "undefined" ||
                window.sessionStorage.getItem("session") == null || window.sessionStorage.getItem("session") == "null") {
                return false;
            } else {
                return true;
            }
        }
        //调起登录
        function detectLogin() {
            if (!window.sessionStorage.getItem("session") || window.sessionStorage.getItem("session") == "" ||
                window.sessionStorage.getItem("session") == undefined || window.sessionStorage.getItem("session") == "undefined" ||
                window.sessionStorage.getItem("session") == null || window.sessionStorage.getItem("session") == "null") {
                // this.$toast("请先登录");
                dsBridge.call("login", "", function(session) {
                    window.sessionStorage.setItem("session", session);
                });
                return false;
            }
        }
        //验证手机号
        function verifyPhone(phoneNum) {
            let telReg = !!phoneNum.match(/^(13[0-9]|14[57]|15[012356789]|16[0-9]|17[0-9]|18[0-9]|19[0-9]|92[0-9]|98[0-9])[0-9]{8}$/);
            return telReg;
        }
        //打电话
        function telephone(phone) {
            window.location.href = "tel://" + phone;
        }
        //发邮件
        function sendMail(emailAddress) {
            window.location.href = "mailto://" + emailAddress;
        }
        //分享至微信 - APP
        function appShare(shareData) {
            let isExist = dsBridge.hasNativeMethod('share');
            if (isExist) {
                // let shareData = {
                //     Title: "分享标题",                //分享标题
                //     Link: "http://www.baidu.com",    //分享链接
                //     Image: "http://d.hiphotos.baidu.com/image/pic/item/024f78f0f736afc3a2a61a56be19ebc4b745125e.jpg", //分享预览图
                //     Desc: "分享描述"
                // };
                dsBridge.call("share", shareData);
            } else {
                alert("请安装U+私人管家最新版");
            }
        }
        //img转base64
        function img2base64(img, parentCallback) {
            const getBase64Image = (img) => {
                var canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                var ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0, img.width, img.height);
                var ext = img.src.substring(img.src.lastIndexOf(".") + 1).toLowerCase();
                var dataURL = canvas.toDataURL("image/" + ext);
                return dataURL;
            }
            var image = new Image();
            image.src = img;
            image.setAttribute('crossOrigin', 'anonymous'); //允许图片跨域请求、必须后台也允许
            image.onload = () => {
                var base64 = getBase64Image(image);
                return parentCallback(base64);
                console.log(base64);
            }
        }
        //获取url中的参数
        function getUrlParam(paramName) {
            // let urlQueryStr = window.location.search; //只能获取第1个"?"后的参数，其他"?"后的获取不到
            let urlQueryStr = window.location.href;
            let paramValue = "";
            if (urlQueryStr.indexOf("?") >= 0 && urlQueryStr.indexOf("=") > 1) {
                let arrQuery = urlQueryStr.split("?"); //此处作多个"?"处理(小程序里传了多个"?")
                for (let i = 0; i < arrQuery.length; i++) {
                    let arrSource = arrQuery[i].split("&");
                    for (let j = 0; j < arrSource.length; j++) {
                        if (arrSource[j].indexOf("=") > 0) {
                            if (arrSource[j].split("=")[0].toLowerCase() == paramName.toLowerCase()) {
                                paramValue = arrSource[j].split("=")[1];
                                break;
                            }
                        } else {
                            break;
                        }
                    }
                    if (paramValue && paramValue != "") {
                        break;
                    }
                }
            }
            return paramValue;
        }
        //设置session
        function setUrlSession() {
            let urlSession = "";
            if (window.sessionStorage.getItem("session") && window.sessionStorage.getItem("session") != "" &&
                window.sessionStorage.getItem("session") != undefined && window.sessionStorage.getItem("session") != "undefined" &&
                window.sessionStorage.getItem("session") != null && window.sessionStorage.getItem("session") != "null") {
                urlSession = window.sessionStorage.getItem("session");
            } else {
                urlSession = getUrlParam("s");
                if (urlSession && urlSession != "") {
                    window.sessionStorage.setItem("session", urlSession);
                }
            }
            return urlSession;
        }
        //是否微信浏览器
        function isWechat(){
            let isWechat = false;
            let ua = window.navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                isWechat = true; //微信浏览器
            } else {
                isWechat = false; //其他浏览器
            }
            return isWechat;
        }
        //手机系统类型
        function getPhoneType(){
            let phonetype = "Android";
            let u = navigator.userAgent;
            //android终端
            let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 || u.indexOf('Linux') > -1;
            //ios终端
            let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            if (isiOS) {
                phonetype = "IOS";
            } else {
                phonetype = "Android";
            }
            return phonetype;
        }
        //是否小程序环境
        function isMiniProgram() {
            let flag = false;
            wx.miniProgram.getEnv(function(res) {
                // console.log(res.miniprogram) // true
                flag = res.miniprogram;
                return flag;
            })
            return flag;
        }
        //小程序 - 调用相册、相机
        function miniProgram_ChooseImage(count, imgSizeType, imgSourceType, configData, parentCallback) {
            // alert("开始调用相册、相机");
            let sizeType = ['original', 'compressed'];
            if (imgSizeType == 1) {
                sizeType = ['original'];
            } else if (imgSizeType == 2) {
                sizeType = ['compressed'];
            } else {
                sizeType = ['original', 'compressed'];
            }
            let sourceType = ['album', 'camera'];
            if (imgSourceType == 1) {
                sourceType = ['album'];
            } else if (imgSourceType == 2) {
                sourceType = ['camera'];
            } else {
                sourceType = ['album', 'camera'];
            }
            let tempFilePaths = [];
            wx.config({
                debug: true,
                appId: configData.AppId,
                timestamp: configData.TimeStamp,
                nonceStr: configData.NonceStr,
                signature: configData.Signature,
                jsApiList: [
                    // 'checkJsApi',
                    'chooseImage' //相册、拍照接口
                ]
            });
            wx.error(function(res) {
                alert(res);
                // alert("出错了：" + res.errMsg);//这个地方的好处就是wx.config配置错误，会弹出窗口哪里错误，然后根据微信文档查询即可。
            });
            wx.ready(function() {
                alert("开始调用相册、拍照接口");
                // wx.checkJsApi({
                //     jsApiList: ['chooseImage'],
                //     success: function(res) {
                //         alert("checkJsApi - chooseImage 成功");
                //     },
                //     fail: function() {
                //         alert("API错误");
                //     }
                // });
                wx.chooseImage({
                    count: 1, //count, // 最多可以选择的图片张数，默认9---------可选多张时，需先处理img2base64多张，即把img按数组处理
                    sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，original 原图，compressed 压缩图，默认二者都有
                    sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，album 从相册选图，camera 使用相机，默认二者都有
                    success: function(res) {
                        alert("调用成功");
                        alert(res.tempFilePaths[0]);
                        // 返回选定照片的本地文件路径列表，tempFilePath可以作为img标签的src属性显示图片
                        let filePaths = res.tempFilePaths;
                        if (filePaths && filePaths.length > 0) {
                            // filePaths.map(item => { //---------可选多张时，需先处理img2base64多张，即把img按数组处理
                            //     img2base64(item.tempFilePath,function(resImg){
                            //         if(resImg){
                            //             tempFilePaths.push(img2base64(resImg));
                            //         }
                            //     });
                            // });
                            img2base64(filePaths[0].tempFilePath, function(resImg) {
                                if (resImg) {
                                    tempFilePaths.push(img2base64(resImg));
                                } else {
                                    tempFilePaths = [];
                                }
                                return parentCallback(tempFilePaths);
                            });
                        } else {
                            tempFilePaths = [];
                            return parentCallback(tempFilePaths);
                        }
                    },
                    fail: function() {
                        alert("调用失败");
                        tempFilePaths = [];
                        return parentCallback(tempFilePaths);
                    }
                });
                // wx.miniProgram.chooseImage({
                //     count: 1, //count, // 最多可以选择的图片张数，默认9---------可选多张时，需先处理img2base64多张，即把img按数组处理
                //     sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，original 原图，compressed 压缩图，默认二者都有
                //     sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，album 从相册选图，camera 使用相机，默认二者都有
                //     success: function(res) {
                //         alert("调用成功22");
                //         alert(res.tempFilePaths[0]);
                //         // 返回选定照片的本地文件路径列表，tempFilePath可以作为img标签的src属性显示图片
                //         let filePaths = res.tempFilePaths;
                //         if (filePaths && filePaths.length > 0) {
                //             // filePaths.map(item => { //---------可选多张时，需先处理img2base64多张，即把img按数组处理
                //             //     img2base64(item.tempFilePath,function(resImg){
                //             //         if(resImg){
                //             //             tempFilePaths.push(img2base64(resImg));
                //             //         }
                //             //     });
                //             // });
                //             img2base64(filePaths[0].tempFilePath, function(resImg) {
                //                 if (resImg) {
                //                     tempFilePaths.push(img2base64(resImg));
                //                 } else {
                //                     tempFilePaths = [];
                //                 }
                //                 return parentCallback(tempFilePaths);
                //             });
                //         } else {
                //             tempFilePaths = [];
                //             return parentCallback(tempFilePaths);
                //         }
                //     },
                //     fail: function() {
                //         alert("调用失败22");
                //         tempFilePaths = [];
                //         return parentCallback(tempFilePaths);
                //     }
                // });
            });
        }
        //小程序 - 导航至
        function miniProgram_NavigateTo(url) {
            wx.miniProgram.navigateTo({
                url: url,
            });
        }
        //小程序 - 当前导航下跳转至
        function miniProgram_RedirectTo(url) {
            wx.miniProgram.redirectTo({
                url: url,
            });
        }
        //小程序 - 分享
        function miniProgram_Share(shareData) {
            let title = encodeURIComponent(shareData.title);
            let url = shareData.url;
            let imageUrl = encodeURIComponent(shareData.imageUrl);
            wx.miniProgram.navigateTo({
                url: "../share/share?title=" + title + "&url=" + url + "&imageUrl=" + imageUrl,
            });
        }
        //小程序 - 退出
        function miniProgram_Logout() {
            wx.miniProgram.redirectTo({
                url: '../logout/logout',
            });
        }
        Vue.prototype.$isLogin = isLogin;
        Vue.prototype.$detectLogin = detectLogin;
        Vue.prototype.$verifyPhone = verifyPhone;
        Vue.prototype.$telephone = telephone;
        Vue.prototype.$sendMail = sendMail;
        Vue.prototype.$appShare = appShare;
        Vue.prototype.$img2base64 = img2base64;
        Vue.prototype.$getUrlParam = getUrlParam;
        Vue.prototype.$setUrlSession = setUrlSession;
        Vue.prototype.$isWechat = isWechat;
        Vue.prototype.$getPhoneType = getPhoneType;
        Vue.prototype.$isMiniProgram = isMiniProgram;
        Vue.prototype.$miniProgram_ChooseImage = miniProgram_ChooseImage;
        Vue.prototype.$miniProgram_NavigateTo = miniProgram_NavigateTo;
        Vue.prototype.$miniProgram_RedirectTo = miniProgram_RedirectTo;
        Vue.prototype.$miniProgram_Share = miniProgram_Share;
        Vue.prototype.$miniProgram_Logout = miniProgram_Logout;
    }
}


// WEBPACK FOOTER //
// ./src/shared/service/tool.js